export default {
    general: {
        password: 'Password',
        or: 'or',
        task: 'Task | Tasks',
        document: 'File',
        register: 'Register',
        folder: 'Folder',
        cancel: 'Cancel',
        yes: 'Yes',
        no: 'No',
        search: 'Search',
        select:'Select',
        close: 'Close',
        promptQuestion: 'Are you sure?',
        sessionExpired: 'Your session has expired',
        loginFirst: 'You must be logged in in order to access the invitation link',
        noPreview: 'File preview not available',
        reloadAppQuestion: 'New enaio coLab version is available. Do you want to reload the app?',
        forbidden: 'You are not a member of this project',
        serverError: 'Server error status {code}',
        notFound: 'Page not found',
        DMS_SERVICE_ERROR: 'DMS service error',
        errorPage: {
            title: 'Page not found',
            body: 'The page you requested is not found',
            backBtn: 'Go Back',
            homeBtn: 'Go to Home',
            objectNotFound: 'Preview for file with id {fileId} is not available, because the shared link is no longer valid'
        },
        about: {
            menuTitle: 'About coLab',
            componentVersion: 'Component version',
            productVersion: 'Product version',
            manufacturer: 'Manufacturer',
            manufacturerText: 'OPTIMAL SYSTEMS GmbH, Berlin, Germany',
            userDocumentation: 'User documentation'
        }
    },
    profile: {
        profile: 'User profile',
        logout: 'Log out',
        language: 'Language',
        title: 'User profile',
        firstName: 'First name',
        lastName: 'Last name',
        email: 'E-mail address',
        selectedLanguage: 'Selected language',
        saveChanges: 'Save changes',
        messages: {
            action: {
                success: 'User profile updated',
                error: 'Error while updating user profile'
            },
            validation: {
                email: 'Enter a valid e-mail address'
            }
        }
    },
    login: {
        username: 'enaio username',
        password: 'enaio password',
        title: 'Welcome to enaio coLab',
        email: 'E-mail address',
        login: 'Login',
        externalUsersTitle: 'External users',
        enaioUsersTitle: 'enaio users',
        loginPending: 'Logging in ...',
        validation: {
            username: 'Username cannot be empty',
            password: 'Password cannot be empty',
            wrongLogin: 'Wrong username or password'
        },
        socialLogins: {
            google: 'Login with Google',
            linkedin: 'Login with LinkedIn',
            microsoft: 'Login with Microsoft',
            keycloak: 'Login with {companyName}'
        }
    },
    menu: {
        home: 'Home',
        overview: 'Overview',
        files: 'Files',
        tasks: 'Tasks',
        settings: 'Settings',
        adminSettings: 'Admin Settings',
        roleName: 'Role name',
        hover: {
            logo: 'Overview of Project rooms',
            home: 'Project home',
            files: 'Project files',
            tasks: 'Project tasks',
            settings: 'Project settings',
            adminSettings: 'Admin Settings',

        }
    },
    message: {
        profile: {
            savedSuccessfully: 'Settings successfully saved'
        },
        wizard: {
            findError: {
                title: 'An error occurred.',
                text: 'If this error occurs repeatedly, contact your administrator.',
                message: 'Error message:'
            }
        }
    },
    tasks: {
        filter: {
            showAll: 'Show all',
            showNotCompleted: 'Hide completed'
        },
        completed: 'Completed',
        title: 'Task group | Task groups',
        noList: 'No lists available',
        noListSelected: 'No list selected',
        addTask: 'Add task',
        editTask: 'Edit task',
        saveChanges: 'Save changes',
        task: 'Task',
        taskgroup: 'Task group',
        modified: 'Modified on',
        addTaskGroup: 'Create group',
        due: 'Due',
        dueNotSet: 'No due date set',
        assignUser: 'Assign user',
        assignedTo: 'Assigned to',
        assignProjectMember: 'Assign Project Member',
        projectMembers: 'Project members',
        startTyping: 'Start typing...',
        removeAssignee: 'Remove assignee',
        filetasktitle: 'Add task for file "{0}"',
        selectTaskGroup: 'Select task group',
        taskGroupName: 'Task group name',
        newTaskGroup: 'Create new task group',
        editTaskGroup: 'Edit task group',
        noTasks: 'No tasks to display',
        newTask: 'Create new task',
        subject: 'Subject',
        description: 'Description',
        dueDate: 'Due date',
        previewAttachments: 'Preview attachments',
        messages: {
            action: {
                success: 'Task created',
                error: 'Error while creating the task',
                errorDeleteTaskGroup: 'Error while deleting the task group',
                errorProjectMemberUpdate: 'Error while updating the project member',
                errorProjectMemberRemove: 'Error while removing the project member',
                errorTaskComplete: 'Error while changing the task completion status',
                errorCreateTaskGroup: 'Error while creating the task group',
            },
            validation: {
                taskGroup: 'Select task group',
                taskName: 'Enter task name',
                taskGroupName: 'Group name cannot be empty',
                taskSubject: 'Task subject cannot be empty',
                taskDueDate: 'Task due date cannot be in the past',
                noMember: 'No member selected'
            }
        }
    },
    project: {
        title: 'Project',
        projectmembers: 'Project members',
        projectmessages: 'Project messages',
        projectdetails: 'Project details',
        opentask: 'assigned task | assigned tasks',
        noOpenTasks: 'No open tasks',
        collaborators: 'Collaborators',
        dashboard: {
            openTasks: 'Open tasks',
            myOpenTasks: 'My open tasks',
            nextTask: 'My next task',
            newMessages: 'New messages',
            zeroProjectMessage: 'You are not a member of any project',
            scrollFinished: 'No more project rooms',
            scrollNoResult: 'No search results',
            projectRoomName: 'Project room name',
            myProjectRooms: 'My project rooms',
            deleteBtnTitle: 'DELETE PROJECT',
            searchPlaceholder: 'Search in Title and Owner',
            labelTotalProjects: 'Total projects:',
            labelDisplayedProjects: 'Displayed projects:',
            labelSearchHitResults: 'Number of hits:',
            labelOwnerBadge: 'OWNER',
            labelOwners: 'Owners:',
            showMembersBtnTitle: 'SHOW MEMBERS',
            membersListModalTitle: 'Project members',
            descriptionSuffix: 'SHOW MORE',
            successMemberDelete: 'Successfully removed member {memberName}',
            errorMemberDelete: 'Member \'{memberName}\' could not be removed',
            noProjectMembership: 'You are not a member of this project'
        },
        action: {
            errorLoading: 'Error while loading project {projectId}',
            successUpdate: 'Project updated',
            errorUpdate: 'Error while updating project {projectName}',
            successDelete: 'Successfully removed project {projectName}',
            errorDelete: 'Project \'{projectName}\' could not be deleted',
            errorLoadingCollaborators: 'Error while loading collaborators for {projectId}'
        },
        settings: {
            general: {
                noGeneralDeletedRoom: 'This project room has been deleted in enaio client or the user has no rights to view it. If you want to remove it from coLab go to "Advanced > Delete project room" or contact your enaio administrator.',
                title: 'General',
                name: 'Project name',
                description: 'Description',
                namePlaceholder: 'Project name',
                descriptionPlaceholder: 'Project description',
                tabGeneral: 'General',
                tabParticipants: 'Members',
                tabGroups: 'Groups',
                tabAdvanced: 'Advanced',
                tabEmails: 'E-mails',
                queryDepth: 'Query Depth',
                rootObject: 'enaio Root Object',
                downloadRootObject: 'Download link to enaio root object',
                uploadObjectType: 'Upload document type',
                showOrHide: 'Show/Hide',
                showMessages: 'Show messages',
                showTasks: 'Show tasks',
                folderOrRegisterNotAvailable: 'Folder or register not available',
                noUploadObjectTypeSelection: 'No document type selected',
                qualified: 'suitable',
                colabTypeAvailable: 'coLab upload type is available',
                noColabTypeAvailable: 'No coLab upload type available',
                contactAdmin: 'Contact your enaio administrator',
                waitingUploadStatus: 'Waiting for coLab upload status...',
                validation: {
                    projectName: 'Project name cannot be empty'
                }
            },
            participants: {
                title: 'Project member',
                invite: 'Invite members',
                itsYou: 'You',
                inviteDlg: {
                    title: 'Invite members',
                    bcc: 'Send Bcc of invitation e-mail',
                    email: 'Users\' e-mail addresses',
                    emailPlaceholder: 'Enter e-mail address(es)',
                    message: 'Message',
                    valid: 'Validity of invitation in days',
                    validPlaceholder: 'Validity in days',
                    send: 'Send invitations',
                    validation: {
                        email: 'Enter one or more valid e-mail addresses',
                        period: 'Enter validity period - 90 days maximum',
                        role: 'Role cannot be empty',
                        bcc: 'Bcc cannot be empty'
                    },
                    action: {
                        info: 'Invitations were sent',
                        error: 'An error occurred while sending invitations',
                        errorInvalidInvitation: 'Invitations have not been sent because one or more e-mail addresses are not valid. Check the e-mail addresses and try sending again'
                    }
                },
                action: {
                    lastOwner: 'Last remaining project owner must not be removed',
                    errorChangeRole: 'Error while changing the member role',
                    errorRemoveMember: 'Error while removing the project member',
                    successUpdateMember: 'Project member updated',
                    errorUpdateMember: 'Error while updating the project member'
                },
                removeMember: 'Remove member',
                changeRole: 'Change member role',
                rolesLabel: 'Roles',
                leaveProject: 'Leave project',
                roles: {
                    guest: 'Guest',
                    member: 'Member',
                    owner: 'Owner'
                }
            },
            invitations: {
                title: 'Invitations',
                status: {
                    active: 'Active',
                    expired: 'Expired'
                },
                text: {
                    created: 'Created on',
                    expires: 'Expires on',
                    noInvitations: 'No invitations to display.',
                    revokeInvitation: 'Revoke invitation'
                },
                errorRevoking: 'Invitation cannot be revoked'
            },
            advanced: {
                title: 'Advanced',
                delete: 'Delete project room',
                deleteMessage: 'Do you really want to delete this project room?',
                validation: {
                    queryDepth: 'Query depth must be a number between 1 and 10'
                },
                exportProjectRoomContents: 'Export with additional project room contents',
                downloadPDF: 'Download project room details PDF',
                includeMessages: 'Include messages',
                includeTasks: 'Include tasks',
                includeMembers: 'Include members',
            },
            emails: {
                assignedTasks: 'Receive e-mail notifications for assigned tasks',
                userEmailAddress: 'E-mail notifications are being sent to',
                noUserEmailAddress: 'There is no e-mail address associated with your account.',
                action: {
                    errorUpdating: 'Error updating e-mail settings',
                    successUpdating: 'E-mail settings updated'
                }
            },
            apply: 'Apply',
            files: {
                zeroSizeFile: 'Only non-empty files can be uploaded',
                noFiles: 'No files to display',
                noFilesDeletedRoom: 'This project room has been deleted in enaio client or the user has no rights to view it. If you want to remove it from coLab go to "Settings > Advanced > Delete project room" or contact your enaio administrator.',
                loadingMessage: 'Loading files, please wait...',
                filteredRowCount: 'Found',
                totalRowCount: 'Total',
                errorLoadingFiles: 'Error while loading files',
                previewAfterResizing: 'Preview available after resizing',
                filterPlaceholder: 'Filter...',
                downloadInProgress: 'Download in progress...',
                downloadSuccess: 'File successfully downloaded',
                uploadInProgress: 'Upload in progress...',
                downloadButton: 'Download files',
                downloadButtonTitle: 'Download selected files as .zip',
                newDocumentButton: 'New file',
                newDocumentButtonTitle: 'Upload new file',
                errorDownloadingFiles: 'Error downloading files',
                noNameFolderTitle: '[UNNAMED_FOLDER]',
                uploadDialog: {
                    title: 'Upload file',
                    fieldTitle: 'Title',
                    fieldInfo: 'Info',
                    fieldFile: 'File',
                    send: 'Upload',
                    dropzoneText: 'Drop file here or click to browse',
                    cancelUploadText: 'Remove file',
                    removeFileText: 'Remove file',
                    messages: {
                        success: 'Upload successful',
                        errorWhileUploading: 'Error while uploading file',
                        colabTypeNotAllowed: 'It is not allowed to upload files in this folder',
                        errorConfig: 'File cannot be uploaded due to incompatible enaio type settings. Contact your project room administrator',
                        maxUploadSizeExceeded: 'Exceeded maximum upload file size of: ',
                        validation: {
                            title: 'Enter file title',
                            file: 'File is not selected',
                            maxFilesReached: 'You cannot upload more than one file'
                        }
                    }
                },
                editDialog: {
                    title: 'Edit file',
                    fieldFile: 'Existing file',
                    send: 'Save changes',
                    fileNotEditable: 'This file cannot be edited, you can only change its title and info',
                    firstRevisionWarning: 'Your upload will overwrite the existing file version. If you want to compare and merge the versions, download the latest version first.',
                    secondRevisionWarning: 'There is a new version of this file. If you upload a new file now, all previous changes will be overwritten. If you want to compare and merge the versions, download the latest version first.',
                    messages: {
                        success: 'Edit successful',
                        errorWhileEditing: 'File could not be uploaded. Please try again later or contact your project room administrator.',
                        validation: {
                            title: 'Provide file title',
                            file: 'File is not selected',
                            maxFilesReached: 'You cannot upload more than one file'
                        }
                    }
                },
                renameDialog: {
                    title: 'Rename file',
                    send: 'Save changes',
                    messages: {
                        success: 'File successfully renamed',
                        error: 'Error while renaming file'
                    }
                },
                replaceDialog: {
                    title: 'Replace file',
                    send: 'Save changes',
                    messages: {
                        success: 'File successfully replaced',
                        error: 'Error while replacing file'
                    }
                }
            }
        },
        invitation: {
            title: 'Invitation to an enaio coLab',
            description: 'You have been invited to project',
            question: 'Would you like to accept the invitation?',
            action: {
                errorLoading: 'Error while loading invitation information',
                errorRedeeming: 'Error while redeeming invitation',
                errorRedeemingExpired: 'Error while redeeming invitation: invitation expired',
                errorRedeemingInvalid: 'Error while redeeming invitation: invitation invalid',
                errorInvalidInvite: 'Invalid invitation',
                errorExpiredInvite: 'Invitation has expired',
                INVALID_EMAIL_FORMAT:'Invalid e-mail format'
            }
        }
    },
    feed: {
        title: 'Project Feeds',
        shareLinkCreated: 'File Share Link Created',
        shareLinkValid: 'This file is shareable until {date}',
        shareLinkNotActive: 'Share link is not active for this file',
        newProjectMember: 'New Project Member',
        newProjectMemberMessage: 'Welcome {userName} to project room {projectName}',
        newMessage: {
            name: 'New message',
            title: 'Title',
            message: 'Message',
            create: 'Create',
            discard: 'Discard'
        },
        editMessage: {
            name: 'Edit message',
            title: 'Title',
            message: 'Message',
            create: 'Save',
            discard: 'Discard'
        },
        updated: 'Updated on',
        activatefeeds: 'Activate feeds',
        messages: {
            action: {
                success: 'Message sent',
                error: 'Error while sending message',
                successDelete: 'Message deleted',
                errorDelete: 'Error while deleting message',
                successUpdate: 'Message updated',
                errorUpdate: 'Error while updating message'
            },
            validation: {
                messageTitle: 'Enter message title',
                messageContent: 'Enter message content'
            }
        },
        action: {
            errorLoadFeed: 'Error while loading feed for {projectId}',
            errorAddFeed: 'Error while adding feed item for {projectId}',
            errorUpdateFeed: 'Error while updating feed item for {projectId}'
        },
        actionButtons: {
            deleteMessage: 'Delete message',
            editMessage: 'Edit message',
            goToFile: 'Go to file'
        }
    },
    files: {
        title: 'Title',
        info: 'Info',
        modified: 'Modified',
        actions: 'Actions',
        context: {
            download: 'Download file',
            replace: 'Replace file',
            createtask: 'Create task',
            createmessage: 'Create message',
            share: 'Share file',
            deleteDocument: 'Delete file',
            editDocument: 'Rename file',
            onlyOffice: 'OnlyOffice',
            deleteTask: 'Delete task',
            editTask: 'Edit task',
            goToFile: 'Go to file',
            createTaskGroup: 'Create task group',
            deleteTaskGroup: 'Delete task group',
            editTaskGroup: 'Edit task group',
            createTask: 'Create task'
        },
        baseparams: {
            created: 'Created',
            updated: 'Updated',
            size: 'Size',
            filetype: 'Type'
        },
        action: {
            errorLoading: 'Error while loading files',
            successDelete: 'File deleted',
            errorDelete: 'Error while deleting file'
        },
        queryDepthWarning: 'Folder is not accessible due to folder depth defined in settings. Please contact the project owner for more information.'
    },
    wizard: {
        title: 'Create a new project room',
        fields: {
            name: 'Name',
            description: 'Description',
            descriptionTemplate: '',
            root: 'Root object',
            queryDepth: 'File query depth'
        },
        placeholder: {
            name: 'Name of project room',
            description: 'Description of project room'
        },
        create: 'Create',
        cancel: 'Cancel',
        owners: 'Owners',
        projectName: 'Project name',
        duplicateProjectsLabel: 'Existing projects from the same folder',
        validation: {
            roomName: 'Enter project room name',
            queryDepth: 'Query depth must be a number between 1 and 10'
        },
        error: {
            title: 'An error occurred.',
            message: 'If this error occurs repeatedly, contact your administrator.',
            onlyFromFolder: 'A project room can only be created from a folder or register',
            objectNotFound: 'The object with id {id} was not found. The reason can be that the technical user doesn\'t have sufficient rights to see this file. Please contact your enaio administrator.',
            duplicateProjects: 'Error while loading existing projects from the same folder'
        }
    },
    share: {
        title: 'Share file externally',
        text: 'Create a share link for the file',
        valid: 'Validity of the link in days',
        linkIsValid: 'The link "{0}" is valid until {1}',
        create: 'Create link',
        deleteLink: 'Cancel sharing',
        close: 'Close',
        notFound: 'Share link is not available',
        messages: {
            action: {
                successRevoke: 'File sharing canceled'
            }
        },
        validation: {
            period: 'Enter validity period - 365 days maximum'
        }
    },
    preview: {
        download: 'Download',
        actions: 'Actions'
    },
    admin: {
        settings: {
            tabJobs: "Jobs",
            tabRolesManagement: "Roles Management",
            job1: "Mark objects shared in coLab",
            description1: "Job that reruns periodically to mark objects in coLab",
            jobs: {
                run: "Run job",
                errorMarkJob: 'Job failed',
                successMarkJob: 'Job successfully run'

            },
            rolesManagement: {
                addRole: "Add new role",
                clone: "Clone",
                edit: "Edit",
                delete: "Delete",
                modal: {
                    save: "Save role"
                },
                roleDialogue: "Assign roles",
                successDeleteRole: 'Role successfully deleted',
                errorDeleteRole: 'You do not have the required permission to carry out this action.',
                successCreateRole: 'Role successfully created/edited',
                errorCreateRole: 'You do not have the required permission to carry out this action.',
                errorAddNewRole: 'Role name is a mandatory field.',
                NAME_TAKEN:'This name already exists',
                ROLE_IN_USE:'Role in use',
                roleName: 'Role name',
                rights: {
                    DOWNLOAD_FILE:"Download file",
                    REPLACE_FILE: "Replace file",
                    CREATE_TASK: "Create task",
                    DELETE_TASK: "Delete task",
                    UPDATE_TASK: "Update task",
                    CREATE_TASK_LIST: "Create task ist",
                    DELETE_TASK_LIST: "Delete task list",
                    UPDATE_TASK_LIST: "Update task list",
                    CREATE_MESSAGE: "Create message",
                    DELETE_MESSAGE: "Delete message",
                    UPDATE_MESSAGE: "Update message",
                    SHARE_FILE: "Share file",
                    CANCEL_SHARE_FILE: "Cancel sharing",
                    DELETE_FILE: "Delete file",
                    RENAME_FILE: "Rename file",
                    ADD_NEW_FILE: "Add new file",
                    CHANGE_PROJECT_ROOM_NAME: "Rename project room",
                    CHANGE_PROJECT_ROOM_DESCRIPTION: "Edit project room description",
                    CHANGE_PROJECT_MEMBER_ROLE: "Edit project member role",
                    EXIT_PROJECT_ROOM: "Exit project room",
                    CREATE_INVITATION:"Create invitation",
                    DELETE_INVITATION:"Delete invitation",
                    CHANGE_EMAIL_NOTIFICATION:"Edit e-mail notification",
                    CHANGE_FILE_TREE_DEPTH:"Edit file tree depth",
                    DELETE_PROJECT_ROOM:"Edit project room",
                    CHANGE_SHOW_MESSAGE:"Change message display",
                    CHANGE_SHOW_TASKS:"Change task display",
                    DELETE_MEMBERSHIP:"Delete membership"
                },

            },
        }
    }
};
